import { z } from 'zod';
import { minimizedProfessionSchema } from './IMinimizedProfession';

export const restrictedAreaNotificationMetadataSchema = z.object({
	tagId: z.string(),
	tagNick: z.string(),
	name: z.string().optional(),
	area: z
		.object({
			areaNick: z.string(),
			areaId: z.string(),
		})
		.optional(),
	floor: z
		.object({
			floorNick: z.string(),
			floorId: z.string(),
		})
		.optional(),
	profession: minimizedProfessionSchema,
});

export type IRestrictedAreaNotificationMetadata = z.infer<typeof restrictedAreaNotificationMetadataSchema>;
